$=jQuery;
function addLoadEvent(func) {
    var oldonload = window.onload;
    if (typeof window.onload != 'function') {
        window.onload = func;
    } else {
        window.onload = function () {
            oldonload();
            func();
        };
    }
}

jQuery(function ($) {

    $(".page-single article .gallery br").remove();

    // --- NOTICE ALERT ---
    $(".notice-alert-close").click(function () {
        $(".notice-alert").slideUp();
    });


    // --- WOOCOMMERCE ---
    $(document).on('click', '.product-quantity-minus', function(e) {
        let quantityInput = $(this).closest(".quantity").children("input");
        let currentQuantity = parseInt($(quantityInput).val());
        let newQuantity = (currentQuantity >= 1) ? (currentQuantity - 1) : 0;
        $(quantityInput).val(newQuantity);
        $('.col-woo-cart .actions .update').prop("disabled", false);
    });

    $(document).on('click', '.product-quantity-plus', function(e) {
        let max_quantity = 99999;
        let quantityInput = $(this).closest(".quantity").children("input");
        let currentQuantity = parseInt($(quantityInput).val());
        if(isNaN(currentQuantity)) currentQuantity = 0;
        let newQuantity = (currentQuantity >= max_quantity) ? max_quantity : (currentQuantity + 1);
        $(quantityInput).val(newQuantity);
        $('.col-woo-cart .actions .update').prop("disabled", false);
    });


    $(document.body).trigger('wc_fragment_refresh');

});

